import { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import logo from "../../assets/logo/logo1.png";
import { useCart } from "../../cart/CartContext";
import { getCartQuantity } from "../../cart/cartUtils";
import CartDrawer from "../Cart/CartDrawer";

const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "Collections", to: "/products" },
  { label: "Nouveautes", to: "/products/news" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { pathname } = useLocation();
  const { items } = useCart();
  const cartCount = useMemo(() => getCartQuantity(items), [items]);

  return (
    <header className="fixed inset-x-0 top-0 z-50 px-4 pt-3 md:px-8 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="surface-panel overflow-hidden rounded-[28px]">
          <div className="bg-[linear-gradient(90deg,rgba(110,45,22,0.94),rgba(186,93,47,0.9))] px-5 py-2 text-[10px] font-semibold uppercase tracking-[0.32em] text-[#fff4ea] md:px-8 md:text-[11px]">
            Livraison rapide a Abidjan • Commande facile sur WhatsApp • Nouveautes chaque semaine
          </div>

          <div className="grid grid-cols-[auto_1fr_auto] items-center gap-4 px-5 py-4 md:px-8 md:py-5">
            <button
              type="button"
              onClick={() => setOpen((prev) => !prev)}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-[rgba(62,35,24,0.1)] bg-white/60 text-xl text-[#2c1b15] md:hidden"
              aria-label="Ouvrir le menu"
            >
              {open ? "×" : "☰"}
            </button>

            <nav className="hidden items-center gap-2 md:flex">
              {navLinks.map((link) => {
                const isActive =
                  pathname === link.to ||
                  (link.to !== "/" && pathname.startsWith(link.to));

                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={`rounded-full px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.28em] transition ${
                      isActive
                        ? "bg-[#2a1b15] text-[#fff4ea]"
                        : "text-[#6e564a] hover:bg-white/80 hover:text-[#2a1b15]"
                    }`}
                  >
                    {link.label}
                  </Link>
                );
              })}
            </nav>

            <div className="flex justify-center md:justify-center">
              <Link
                to="/"
                aria-label="Si’Bella Boutique"
                className="flex items-center gap-3"
              >
                <span className="hidden h-11 w-11 items-center justify-center rounded-full bg-[#f3ded0] text-[11px] font-semibold uppercase tracking-[0.3em] text-[#7b391f] sm:flex">
                  SB
                </span>
                <img
                  src={logo}
                  alt="Si’Bella Boutique"
                  className="h-14 w-auto object-contain md:h-16"
                />
              </Link>
            </div>

            <div className="flex items-center justify-end gap-3">
              <Link
                to="/products/news"
                className="hidden rounded-full border border-[rgba(62,35,24,0.1)] bg-white/70 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.28em] text-[#6c5548] transition hover:border-[rgba(110,45,22,0.16)] hover:text-[#2c1b15] lg:inline-flex"
              >
                Coup de coeur
              </Link>

              <button
                type="button"
                onClick={() => setIsCartOpen(true)}
                className="glow-ring relative inline-flex items-center gap-3 rounded-full bg-[#201410] px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.28em] text-[#fff3ea] transition hover:-translate-y-0.5 md:px-5"
                aria-label="Panier"
              >
                Panier
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#fff2e7] text-base text-[#2b1a14]">
                  👜
                </span>
                {cartCount > 0 && (
                  <span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-[#d46a36] px-1 text-[10px] text-white">
                    {cartCount}
                  </span>
                )}
              </button>
            </div>
          </div>

          {open && (
            <div className="border-t border-[rgba(62,35,24,0.08)] bg-white/70 px-5 py-5 md:hidden">
              <nav className="flex flex-col gap-3">
                {navLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={() => setOpen(false)}
                    className="rounded-2xl border border-[rgba(62,35,24,0.08)] bg-white/80 px-4 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-[#2c1b15]"
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </div>
          )}
        </div>
      </div>

      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </header>
  );
}
